module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Control-XD-1.aa515b13.png";